export default "__VITE_ASSET__ogMwzOrC__"